import { TicketRepository } from '../repositories/TicketRepository'

export function ListAreaResponsibleCase(ticketRepository: TicketRepository) {
  return async function ({
    areaId,
    subareaId
  }: {
    areaId: string
    subareaId?: string
  }) {
    return await ticketRepository.listAreaResponsible({ areaId, subareaId })
  }
}
